import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/picture-pick/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={655}
              height={871}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F44336" }}>Solution</span>
            </h2>
            <p>
              We were able to develop a complex sequence of rule implementation
              algorithms, based on a set of predefined conditions. To this, our
              team included resulting reward combinations wherever applicable,
              and created this addictive game that is sure to entertain the
              gamer inside you. To make sure that the app could cater to large
              clusters, irrespective of age, gender or interests, we gave it a
              simplistic design and intuitive user experience.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
